/* Native disclosure navigation: keyboard friendly and works without JavaScript. */
(() => {
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.lf-mobile-menu[open]').forEach(menu => {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.lf-mobile-menu[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function pauseBackgrounds() {
    if (motion.matches) document.querySelectorAll('.lees-hero__video').forEach(video => video.pause());
  }
  pauseBackgrounds();
  motion.addEventListener('change', pauseBackgrounds);
})();
